"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ChevronRightIcon_1 = require("../../../Icons/Assets/ChevronRightIcon");
var FolderIcon_1 = require("../../../Icons/Assets/FolderIcon");
var PageIcon_1 = require("../../../Icons/Assets/PageIcon");
var CaptionPath_styles_1 = require("./CaptionPath.styles");
exports.default = (function (_a) {
    var Caption = _a.Caption, Path = _a.Path, IsSelected = _a.IsSelected, IsHovered = _a.IsHovered, IsFolder = _a.IsFolder;
    return (React.createElement(CaptionPath_styles_1.CaptionPathWrapper, { IsFolder: IsFolder, HasPath: !IsFolder && !!Path },
        React.createElement(CaptionPath_styles_1.IconWrapper, { IsHovered: IsHovered, IsSelected: IsSelected }, IsFolder
            ? React.createElement(FolderIcon_1.FolderIcon, null)
            : React.createElement(PageIcon_1.PageIcon, null)),
        React.createElement(CaptionPath_styles_1.CaptionWrapper, { IsHovered: IsHovered, IsSelected: IsSelected },
            Caption,
            Path && React.createElement(CaptionPath_styles_1.DescriptionWrapper, { IsHovered: IsHovered, IsSelected: IsSelected }, Path)),
        IsFolder && React.createElement(CaptionPath_styles_1.IconWrapper, { IsHovered: IsHovered, IsSelected: IsSelected },
            React.createElement(ChevronRightIcon_1.ChevronRightIcon, null))));
});
